import { render, staticRenderFns } from "./Proprietario.vue?vue&type=template&id=686cf0f7&"
import script from "./Proprietario.vue?vue&type=script&lang=js&"
export * from "./Proprietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports